import { ContentLayoutVariant } from '@silvertours/common-landingpages-view';

type StageVariantConfig = {
  isMinimal: boolean;
  isPlain: boolean;
  isErrorPage: boolean;
  isPromoPage: boolean;
  showImage: boolean;
};

export const resolveStageVariantConfig = (
  variant: ContentLayoutVariant,
): StageVariantConfig => {
  switch (variant.kind) {
    case 'default':
    case 'reviewsPillar':
    case 'newsletter':
      return {
        isMinimal: false,
        isPlain: false,
        isErrorPage: false,
        isPromoPage: false,
        showImage: true,
      };
    case 'plain':
      return {
        isMinimal: false,
        isPlain: true,
        isErrorPage: false,
        isPromoPage: false,
        showImage: true,
      };
    case 'promo':
      return {
        isMinimal: false,
        isPlain: true,
        isErrorPage: false,
        isPromoPage: true,
        showImage: true,
      };
    case 'minimal':
      return {
        isMinimal: true,
        isPlain: false,
        isErrorPage: false,
        isPromoPage: false,
        showImage: variant.searchMask !== 'thin',
      };
    case 'error':
      return {
        isMinimal: false,
        isPlain: false,
        isErrorPage: true,
        isPromoPage: false,
        showImage: true,
      };
    default: {
      const unhandledVariant: never = variant;
      throw new Error(`Unhandled variant: ${unhandledVariant}`);
    }
  }
};
